import { Check } from "lucide-react";

const diffs = [
  "Estratégia B2B antes de qualquer linha de código.",
  "Stack moderna, rápida e preparada para SEO técnico.",
  "Entrega previsível, comunicação clara e sem ruído.",
  "Resultado medido em leads, vendas e eficiência operacional.",
];

const About = () => {
  return (
    <section id="sobre" data-testid="about-section" className="bg-[#0a0a0a]">
      <div className="grid grid-cols-1 lg:grid-cols-5">
        {/* TEXT - 60% */}
        <div className="lg:col-span-3 px-5 sm:px-12 py-20 md:py-28 relative">
          <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-6 vc-reveal">
            ✦ Sobre a agência
          </div>
          <h2 className="font-display text-[#ff6b35] text-4xl sm:text-6xl uppercase leading-[0.95] vc-reveal">
            Mais que código,<br />criamos <span className="text-white">crescimento.</span>
          </h2>
          <p className="text-white/80 text-lg mt-8 max-w-xl vc-reveal">
            Somos um parceiro de desenvolvimento web para empresas em Portugal. Combinamos
            estratégia, UX/UI e engenharia limpa para construir sites empresariais, aplicações
            web e sistemas digitais que geram procura qualificada.
          </p>

          <ul className="mt-10 space-y-4">
            {diffs.map((d, i) => (
              <li
                key={d}
                data-testid={`about-diff-${i}`}
                className="flex items-start gap-4 vc-reveal"
              >
                <span className="bg-[#ff6b35] brutal-border w-8 h-8 flex items-center justify-center shrink-0">
                  <Check size={16} className="text-[#0a0a0a]" strokeWidth={3} />
                </span>
                <span className="text-white text-base sm:text-lg">{d}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* VISUAL - 40% */}
        <div className="lg:col-span-2 bg-[#ff6b35] noise relative px-5 sm:px-10 py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 dot-pattern opacity-15 pointer-events-none" />

          <div className="relative grid grid-cols-2 gap-4">
            <div className="bg-white brutal-border-thick p-5 brutal-shadow">
              <div className="font-display text-5xl text-[#0a0a0a]">50+</div>
              <div className="font-mono text-[10px] uppercase tracking-widest mt-1">Projetos</div>
            </div>
            <div className="bg-[#0a0a0a] brutal-border-thick p-5 brutal-shadow translate-y-6">
              <div className="font-display text-5xl text-[#ff6b35]">30+</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-white mt-1">
                Clientes
              </div>
            </div>
            <div className="bg-[#0a0a0a] brutal-border-thick p-5 brutal-shadow -translate-y-2">
              <div className="font-display text-5xl text-white">100%</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-[#ff6b35] mt-1">
                Satisfação
              </div>
            </div>
            <div className="bg-white brutal-border-thick p-5 brutal-shadow translate-y-4">
              <div className="font-display text-5xl text-[#0a0a0a]">7d</div>
              <div className="font-mono text-[10px] uppercase tracking-widest mt-1">
                Resposta
              </div>
            </div>
          </div>

          <div className="mt-10 bg-[#0a0a0a] brutal-border-thick p-6 relative">
            <div className="font-display text-white text-2xl uppercase leading-tight">
              "Trabalhamos com empresas que precisam <span className="text-[#ff6b35]">crescer com tecnologia.</span>"
            </div>
            <div className="font-mono text-xs uppercase text-white/60 mt-3 tracking-widest">
              ✦ equipa BezierClick
            </div>
          </div>

          {/* triangle decoration */}
          <div
            className="absolute bottom-8 right-6 w-0 h-0 hidden md:block"
            style={{
              borderLeft: "24px solid transparent",
              borderRight: "24px solid transparent",
              borderBottom: "42px solid #0a0a0a",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default About;
